export const ACCORDION_CONTENT = 'accordion-content'
export const CLOSE = 'close'
